<div class="modal-content">
    <!-- Header -->
    <div class="modal-header">
        <div class="header-left">
            <h2 class="modal-title">{{ data.title }}</h2>
            @if(data.subtitle) {
            <p class="modal-subtitle">{{ data.subtitle }}</p>
            }
            @if(data.icon) {
            <mat-icon class="icon-confirmation" [svgIcon]="data.icon"></mat-icon>
            }
        </div>
        <button (click)="onClose(false)" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Body com scroll -->
    <div class="modal-body">
        <div class="description-container">
            <span [innerHTML]="sanatizeMessage"> </span>
        </div>
    </div>

    <!-- Footer fixo com botão Salvar -->
    <div class="modal-footer">
        <button-induxtry (action)="onClose(true)" [buttonProperties]="{ 
          label: data?.confirmButtonName || 'Confirmar', 
          customStyle: 'primary', 
          showLabel: true,
        }">
        </button-induxtry>
        <button-induxtry (action)="onClose(false)" [buttonProperties]="{ 
          label: data?.cancelButtonName || 'Cancelar', 
          customStyle: 'secondary', 
          showLabel: true,
        }">
        </button-induxtry>
    </div>
</div>